
import React,{useState} from 'react'
import { Card, Button } from 'react-bootstrap';
import { FaDesktop, FaServer, FaTools } from 'react-icons/fa';
import TrackVisibility from 'react-on-screen';

import javascriptLogo from "../assets/img/javascript-logo.png";
import reactLogo from "../assets/img/react-logo.png";
import reduxLogo from "../assets/img/redux-logo.png";
import nodeLogo from "../assets/img/node-logo.png";
import expressLogo from "../assets/img/express-logo.png";
import mongoLogo from "../assets/img/mongodb-logo.png";
import mysqlLogo from '../assets/img/mysql-logo.png'
import gitLogo from "../assets/img/git-logo.png";
import jestLogo from "../assets/img/jest-logo.png";
import linux from '../assets/img/linux-logo.png'
import Hover from '../components/hoverImge/Hover'

import { Git } from 'react-bootstrap-icons';






export const Skills = () => {
const [hovered, setHovered] = useState(false);

const handleMouseEnter = () => {
  setHovered(true);
};

const handleMouseLeave = () => {
  setHovered(false);
};

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center">
              <h2>Skills</h2>
              <p>
              Learn how I can help your business

              </p>
            </div>
          </div>
        </div>
        <TrackVisibility> 
        {({ isVisible }) =>
        <div className={isVisible ? "row animate__animated animate__fadeInUp":"row"}>
          <div className="col-lg-4 col-md-6  card-margin  " >
            <Card className="skill-card ">
              <Card.Body >
                <Card.Title className='title-card text-sm'>  Frontend Development</Card.Title>
                <Card.Text className='text-card'>
                  <Hover 
                    src={javascriptLogo}
                    alt="Image Description"
                    name="Javascript"/>
                                      <Hover 
                    src={reactLogo}
                    alt="Image Description"
                    name="React Js"/>
                                      <Hover 
                    src={reduxLogo}
                    alt="Image Description"
                    name="Redux"/>
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
          <div className="col-lg-4 col-md-6 card-margin ">
            <Card className="skill-card">
              <Card.Body>
                <Card.Title className='title-card text-sm'>Backend Development</Card.Title>
                <Card.Text className='text-card' >
                <Hover 
                    src={nodeLogo}
                    alt="Image Description"
                    name="Node Js"/>
                                      <Hover 
                    src={mysqlLogo}
                    alt="Image Description"
                    name="MySql"/>
                                      <Hover 
                    src={expressLogo}
                    alt="Image Description"
                    name="Express Js"/>
                     <Hover 
                    src={mongoLogo}
                    alt="Image Description"
                    name="Mongodb"/>

                </Card.Text>  
              </Card.Body>
            </Card>
          </div>
          <div className="col-lg-4 col-md-6  card-margin  ">
            <Card className="skill-card">
              <Card.Body>
                <Card.Title className='title-card text-sm '>Tools & Technologies</Card.Title>
                <Card.Text className='text-card'>
                <Hover 
                    src={gitLogo}
                    alt="Image Description"
                    name="Git"/>
                <Hover 
                    src={jestLogo}
                    alt="Image Description"
                    name="Jest"/>
                <Hover 
                    src={linux}
                    alt="Image Description"
                    name="Linux"/>
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
        </div>
          }
        </TrackVisibility>
        </div>
       
    </section>
  )
}
